import React from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";

interface AppDatePickerProps {
  value?: string | null;
  onChange: (value: string | null) => void;
  maxDate?: Dayjs;
  minDate?: Dayjs;
  label?: string;
}

const AppDatePicker: React.FC<AppDatePickerProps> = ({
  value,
  onChange,
  maxDate,
  minDate,
  label,
}) => {
  return (
    <DatePicker
      label={label}
      format="DD/MM/YYYY"
      desktopModeMediaQuery="@media (min-width: 0px)"
      value={value ? dayjs(value) : null}
      maxDate={maxDate}
      minDate={minDate}
      onChange={(newValue) => {
        onChange(newValue ? newValue.format("YYYY-MM-DD") : null);
      }}
      slotProps={{
        textField: {
          fullWidth: true,
          size: "small",
          variant: "outlined",
          inputProps: {
            inputMode: "numeric",
            placeholder: "DD/MM/YYYY",
          },
          sx: {
            "& input": {
              fontSize: "0.9rem",
            },
            "& .MuiInputAdornment-root": {
              marginRight: 0,
            },
          },
        },
      }}
    />
  );
};

export default AppDatePicker;
